



import BlogListComponent from "@/components/admin/blog/blogListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BlogListPage",
  components: {
    BlogListComponent,
  },
})
export default class BlogListPage extends Vue {}
